import React from "react";

import { getPfizerSonnexusFreeDrugFormInitialValues } from "./form/initialValues";
import { SaveButton } from "../../header";
import useBaseEEConfiguration from "../../hooks/useBaseEEConfiguration";
import { applyTrimFields } from "../../utils/updateFormData";
import renderReactFromJson from "../../utils/renderReactFromJson";
import formJson from "./form/PfizerFreeDrugSonnexusFormJson.json";
import { CompleteFormButton } from "../../CompleteFormButton";
import { SignerTypes } from "../../../../../constant/ESign";
import { HEADER_SUBMIT_BUTTON_TYPES } from "../../constants";
import { fileTypes, MB } from "../../../../Uploader";

export const usePfizerFreeDrugSonnexusConfiguration = () => {
  const vendorName = "pfizerSonnexus";
  const eePlanType = "free_drug";
  const rootPath = "application_form_editor.pfizer_sonnexus.free_drug"; //EE TODO: add data to src/locales/translations/en/ApplicationFormEditor.js

  const baseConfig = useBaseEEConfiguration({ vendorName, eePlanType, rootPath, formJson });

  const pfizerSonnexusSpecificConfig = {
    activeFormSection: "",
    shouldLoadTreatments: true,
    shouldLoadPatientDiagnosis: true,
    getFormInitialValues: ({ applicationForm, treatments, diagnosis }) =>
      getPfizerSonnexusFreeDrugFormInitialValues({ applicationForm, formJson, treatments, diagnosis }),
    getFormFromJson: (form) => renderReactFromJson(form, formJson),
    saveButton: (props) => (
      <SaveButton onSave={(form) => applyTrimFields(form)} id={"EE_pfizer_sonnexus_free_drug_save_form"} {...props} />
    ),
    afterSubmissionPayload: () => ({}),
    applicationFormHeaderSubmission: (props) => <CompleteFormButton id={"EE_complete_button"} {...props} />,
    headerSubmitButtonType: HEADER_SUBMIT_BUTTON_TYPES.COMPLETE_FORM,
    attachmentsSectionFileTypesAccepted: fileTypes.PDF,
    attachmentsSectionMaxFileSize: 6 * MB,
    shouldShowFileSize: true,
    shouldShowPdfInSecondStep: true,
    getSignatureWidgetSettingsBySignerType: (signerType) => {
      const signatureSettings = {
        [SignerTypes.PATIENT_OR_CAREGIVER]: {
          editable: true,
          titleTranslationKey: "patientApplications.enroll.electronic_signatures.signature_step.signers.patient",
          shouldShowCaregiverIndication: false,
          shouldUseRemoteRequestCheckboxes: false
        },
        [SignerTypes.PHYSICIAN]: {
          editable: true,
          titleTranslationKey: "patientApplications.enroll.electronic_signatures.signature_step.signers.physician",
          shouldShowCaregiverIndication: false,
          shouldUseRemoteRequestCheckboxes: false
        }
      };
      return signatureSettings[signerType];
    }
  };

  return {
    ...baseConfig,
    ...pfizerSonnexusSpecificConfig
  };
};

export default usePfizerFreeDrugSonnexusConfiguration;
